import mutations from './packages.mutations'
import actions from './packages.actions'
import getters from './packages.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
